/**
 * Transaction step for progress tracking
 */
export type TransactionStep = "idle" | "building" | "signing" | "confirming" | "complete";

/**
 * Transaction state for hooks
 */
export interface TransactionState {
    /** Whether transaction is in progress */
    isLoading: boolean;
    /** Whether transaction succeeded */
    isSuccess: boolean;
    /** Whether transaction failed */
    isError: boolean;
    /** Error message if failed */
    errorMessage: string | null;
    /** Transaction signature if sent */
    signature: string | null;
    /** Current step in the transaction flow */
    step: TransactionStep;
}

/**
 * Initial transaction state
 */
export const INITIAL_TRANSACTION_STATE: TransactionState = {
    isLoading: false,
    isSuccess: false,
    isError: false,
    errorMessage: null,
    signature: null,
    step: "idle"
};
